import { Fragment, h } from 'preact'; /** @jsx h */
import truncate from '../../utils/truncate';

import './productItem.scss';

const arrowRight = (
    <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 24 24" width="30">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
    </svg>
);

const ProductItem = ({ product, isFeatured = false }) => {
    const {
        id,
        imageUrl,
        name,
        catName,
        descShort,
        description,
        price,
        slug,
        featuredText,
        tag,
        tag_tekst: tagText
    } = product;

    // rewrite the catName to a URL friendly string
    const catNameSlug = catName.replace(/ /g, '-').toLowerCase();

    const isTag = tag === '1' && tagText !== '';

    return (
        <a
            href={`/nettbutikk/${catNameSlug || ''}/${slug || ''}`}
            className={`ws-item ${isFeatured ? 'ws-featured-item' : ''} ${
                isTag ? 'ws-tag-item' : ''
            }`}
            key={id}
        >
            <div className="ws-item-content">
                <div className="ws-item-image-wrapper">
                    {isFeatured && (
                        <div className="ribbon ribbon-top-left">
                            <span>{featuredText}</span>
                        </div>
                    )}
                    {isTag && (
                        <div className="ribbon ribbon-top-left">
                            <span>{tagText}</span>
                        </div>
                    )}
                    <div className="ws-item-image">
                        <img src={imageUrl} alt={name} />
                    </div>
                </div>
                {isFeatured ? (
                    <div className="featured-content">
                        <p className="ws-item-category ws-item-text">{catName}</p>
                        <div className="ws-item-title">
                            <h5 className="ws-item-title-inner">{name}</h5>
                        </div>
                        <p className="ws-item-description ws-item-text">
                            {truncate(description, 370)}
                        </p>
                        <div className="ws-item-price ws-item-text">
                            <span>Fra kr. {price},-</span>
                            <span>{arrowRight}</span>
                        </div>
                    </div>
                ) : (
                    <>
                        <p className="ws-item-category ws-item-text">{catName}</p>
                        <div className="ws-item-title">
                            <h5 className="ws-item-title-inner">{name}</h5>
                        </div>
                        <p className="ws-item-description ws-item-text">
                            {descShort || truncate(description, 130)}
                        </p>
                        <div className="ws-item-price ws-item-text">
                            <span>Fra kr. {price},-</span>
                            <span>{arrowRight}</span>
                        </div>
                    </>
                )}
            </div>
        </a>
    );
};

export default ProductItem;
